import { init } from '@plausible-analytics/tracker'

export function initPlausible() {
  if (import.meta.env.VITE_PLAUSIBLE_ENABLED === 'true') {
    init({
      domain: import.meta.env.VITE_PLAUSIBLE_DOMAIN,
      endpoint: import.meta.env.VITE_PLAUSIBLE_ENDPOINT,
    })
  }
}
